module.exports = __webpack_public_path__ + "img/EnConstru.950b4d51.png";